import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest } from 'src/utils/request';

import type { RequestDataArray } from 'src/types/requestData';

const mapTutorials = (tutorial: UCM.TutorialRawType, tutorialId: string) => ({
  id: tutorialId,
  code: tutorial.code,
  uuid: tutorial.uuid,
  kind: tutorial.kind,
  cohort: tutorial.cohort,
  title: {
    de: tutorial.title_de,
    en: tutorial.title_en,
  },
  description: {
    de: tutorial.description_de,
    en: tutorial.description_en,
  },
  deletable: tutorial.deletable,
});

const getTutorials = async () => {
  const {
    data: { data },
  } = await getRequest<RequestDataArray<UCM.TutorialRawType>>(
    `${API.GET.tutorials}`,
  );

  return data.map(({ attributes, id }) => mapTutorials(attributes, id));
};

export const useGetTutorials = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.TUTORIALS],
    queryFn: () => getTutorials(),
    staleTime: 1000 * 60 * 5, // Dashboards refreshed after every 5 minutes automatically
    ...config,
  });
};
